import { ArrowRight, Coffee, Music2, Sparkles } from "lucide-react";
import dayCareImage from "../assets/dagbesteding-groepsactiviteit.jpg";

export const DAY_CARE_FEATURES = [
  { icon: Coffee, title: "Smaken en gewoonten", description: "Vertrouwde gerechten, geuren en dagelijkse rituelen die herinneringen en gesprek op gang brengen." },
  { icon: Music2, title: "Taal, muziek en verhalen", description: "Ruimte voor moedertaal, bekende muziek en persoonlijke geschiedenis uit de Molukse en Indische gemeenschap." },
  { icon: Sparkles, title: "Rust, ritme en aandacht", description: "Een overzichtelijke dagstructuur die aansluit bij wat deelnemers aankunnen en prettig vinden." }
];

const DayCareOverview = ({ content }) => {
  const image = content?.daycare_image_url || dayCareImage;
  const features = [
    { icon: Coffee, title: content?.daycare_feature_1_title || DAY_CARE_FEATURES[0].title, description: content?.daycare_feature_1_text || DAY_CARE_FEATURES[0].description },
    { icon: Music2, title: content?.daycare_feature_2_title || DAY_CARE_FEATURES[1].title, description: content?.daycare_feature_2_text || DAY_CARE_FEATURES[1].description },
    { icon: Sparkles, title: content?.daycare_feature_3_title || DAY_CARE_FEATURES[2].title, description: content?.daycare_feature_3_text || DAY_CARE_FEATURES[2].description }
  ];
  return (
  <>
    <section className="bg-white py-12 md:py-16 lg:py-20">
      <div className="mx-auto grid max-w-7xl items-center gap-10 px-4 sm:px-6 lg:grid-cols-[minmax(0,0.9fr)_minmax(0,1.1fr)] lg:gap-16 lg:px-8">
        <div className="max-w-xl">
          <p className="section-label">{content?.daycare_label || "Dagbesteding"}</p>
          <h1 className="section-title">{content?.daycare_title || "Een dag die vertrouwd voelt"}</h1>
          <div className="mt-5 space-y-4 text-lg leading-relaxed text-muted-foreground">
            <p>{content?.daycare_intro_1 || "Rumah Kasih biedt dagbesteding in Winterswijk voor Molukse en Indische ouderen en voor ouderen met affiniteit met deze gemeenschappen, bijvoorbeeld door hun geboorte, levensgeschiedenis of culturele verbondenheid."}</p>
            <p>{content?.daycare_intro_2 || "Er is extra aandacht voor deelnemers met dementie, Alzheimer en andere hersenaandoeningen."}</p>
            <p>{content?.daycare_intro_3 || "Cultuur staat niet los op het programma, maar krijgt een plek in de hele dag: in hoe mensen worden begroet, samen eten, herinneringen delen en contact maken."}</p>
          </div>
        </div>
        <figure className="overflow-hidden rounded-md bg-secondary">
          <img src={image} alt={content?.daycare_image_alt || "Oudere deelnemers die samen aan tafel een rustige activiteit doen"} className="aspect-[4/3] h-full w-full object-cover object-center" loading="eager" decoding="async" />
          <figcaption className="sr-only">Een vertrouwde dag met persoonlijke aandacht en herkenbare activiteiten.</figcaption>
        </figure>
      </div>
    </section>

    <section className="bg-secondary/40 py-12 md:py-16" aria-labelledby="day-care-pillars">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <p className="section-label">{content?.daycare_features_label || "Herkenning in de hele dag"}</p>
          <h2 id="day-care-pillars" className="mt-3 font-heading text-3xl font-bold sm:text-4xl">{content?.daycare_features_title || "Wat vertrouwdheid concreet betekent"}</h2>
        </div>
        <div className="mt-8 grid border-y border-border md:grid-cols-3 md:divide-x md:divide-border">
          {features.map(({ icon: Icon, title, description }) => (
            <article key={title} className="border-b border-border py-7 last:border-b-0 md:border-b-0 md:px-7 md:first:pl-0 md:last:pr-0">
              <Icon className="h-7 w-7 text-accent" aria-hidden="true" />
              <h3 className="mt-4 font-heading text-xl font-semibold">{title}</h3>
              <p className="mt-3 leading-relaxed text-muted-foreground">{description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>

    <aside className="bg-primary text-primary-foreground" aria-labelledby="day-care-status">
      <div className="mx-auto flex max-w-7xl flex-col gap-7 px-4 py-10 sm:px-6 md:flex-row md:items-center md:justify-between lg:px-8">
        <div className="max-w-3xl">
          <p className="text-sm font-bold uppercase text-secondary">{content?.daycare_status_label || "Iedere dinsdag van 10.00 tot 13.00 uur"}</p>
          <h2 id="day-care-status" className="mt-2 font-heading text-2xl font-semibold sm:text-3xl">{content?.daycare_status_title || "De dagbesteding is gestart"}</h2>
          <p className="mt-3 text-lg leading-relaxed text-white/80">{content?.daycare_status_text || "Dinsdag 14 juli 2026 is de laatste bijeenkomst voor de zomerstop. Daarna is Rumah Kasih zes weken gesloten. Actuele data publiceren we in de agenda."}</p>
        </div>
        <a href="/contact" className="inline-flex h-10 w-full shrink-0 items-center justify-center rounded-md bg-accent px-4 text-sm font-medium text-white transition-colors hover:bg-accent/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white sm:w-auto">
          Neem contact op <ArrowRight className="ml-2 h-4 w-4" aria-hidden="true" />
        </a>
      </div>
    </aside>
  </>
  );
};

export default DayCareOverview;
